/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ERP API
 * 날짜·요일·시간 요청 및 응답은 UTC 기준입니다. 시간대 없는 date/time/date-time 값도 UTC로 해석하며 서버에서 KST로 변환하지 않습니다. 프런트에서 시간대를 변환할 때 날짜와 요일도 함께 변환해야 합니다. 날짜 검색의 from/to는 UTC 시작 포함·종료 미포함입니다. time_zone을 지원하는 조회의 날짜 그룹은 해당 시간대를 따릅니다. 생일 등 날짜 자체를 의미하는 값은 입력한 날짜를 그대로 사용합니다.
 * OpenAPI spec version: v1
 */
import type { BaseResponseListInstructorMyLessonResponse } from '.././models';

import { customInstance } from '../../../../shared/apiClient/orvalMutator';

export const getInstructorMe = () => {
  /**
   * @summary 강사 본인 수업 조회
   */
  const instructorMeGetMyLessons = () => {
    return customInstance<BaseResponseListInstructorMyLessonResponse>({ url: `/api/instructor/me/lessons`, method: 'GET' });
  };
  return { instructorMeGetMyLessons };
};
export type InstructorMeGetMyLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInstructorMe>['instructorMeGetMyLessons']>>>;
